<div class="standard-cutouts-content" *ngIf="data$ | async as data">
  <ng-container *ngIf="!data.error">
    <csl-standard-cutout-select
      [cutouts]="data.result"
      (selectChanged)="selectChanged.emit($event)"></csl-standard-cutout-select>
  </ng-container>

  <div *ngIf="!data.error && !data.result" class="p-4">Loading…</div>
  <div *ngIf="data.error">{{ data.error | json }}</div>
</div>
